<div class="ipsative-block">
  <table class="ipsative-table" role="table">
    <thead>
      <tr>
        <th class="stmt-col" scope="col"></th>
        <th class="role-col" scope="col">Most like me</th>
        <th class="role-col" scope="col">Least like me</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let statement of statements">
        <td class="stmt-col" [innerHTML]="statement.optionhtml"></td>
        <td class="role-col">
          <input type="radio" class="ipsative-radio" [name]="'most_' + schedulequestionid"
            [checked]="mostOptionId === statement.optionid" (change)="selectMost(statement.optionid)"
            [attr.aria-label]="'Most like me'" />
        </td>
        <td class="role-col">
          <input type="radio" class="ipsative-radio" [name]="'least_' + schedulequestionid"
            [checked]="leastOptionId === statement.optionid" (change)="selectLeast(statement.optionid)"
            [attr.aria-label]="'Least like me'" />
        </td>
      </tr>
    </tbody>
  </table>
</div>
